/* Star Maps UAE — cart line-item change fix (Prestige 10.x)
 * Problem: Shopify re-hashes line-item keys whenever a cart with line properties is mutated,
 * and an app (Whatmore) writes cart attributes ~1.5 s after every add. Prestige's drawer / cart
 * page render Remove and +/- controls with the key from the moment they were rendered, so
 * POST /cart/change.js {id: <stale key>} returns 400 and nothing happens.
 * Fix: translate Prestige's key-based change requests into line-index requests (stable), using
 * the position of the <line-item> the customer tapped, verified against the live cart.
 */
(function () {
  'use strict';

  var RECENT_MS = 4000; // a tap is considered to belong to the next change request within this window
  var last = { line: 0, variantId: 0, at: 0 };

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* Remember which line the customer tapped (drawer or cart page), by DOM order. */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('line-item') : null;
    if (!el) return;
    var scope = el.closest('cart-drawer') || el.closest('form[action*="/cart"]') || el.closest('main') || document;
    var all = Array.prototype.slice.call(scope.querySelectorAll('line-item'));
    var idx = all.indexOf(el);
    if (idx < 0) return;
    var link = el.querySelector('a[href*="/cart/change"]');
    var key = link ? (link.getAttribute('href').match(/[?&]id=([^&]+)/) || [])[1] : '';
    last = { line: idx + 1, variantId: key ? parseInt(key.split(':')[0], 10) : 0, at: Date.now() };
  }, true);

  /* Resolve the line index for a change request whose key may be stale. */
  function resolveLine(key, cart) {
    var variantId = parseInt(String(key).split(':')[0], 10);
    var items = cart.items || [];
    // 1. key still valid → use its exact position
    for (var i = 0; i < items.length; i++) if (items[i].key === key) return i + 1;
    // 2. recent tap on a line whose position holds that variant → trust the tap
    if (Date.now() - last.at < RECENT_MS && last.line > 0 && items[last.line - 1] &&
        items[last.line - 1].variant_id === variantId) return last.line;
    // 3. only one line with that variant → unambiguous
    var matches = [];
    for (var j = 0; j < items.length; j++) if (items[j].variant_id === variantId) matches.push(j + 1);
    if (matches.length === 1) return matches[0];
    // 4. several lines with that variant and a recent tap → nth same-variant line by tap position
    if (matches.length > 1 && Date.now() - last.at < RECENT_MS) {
      var domLines = Array.prototype.slice.call(document.querySelectorAll('cart-drawer line-item, main line-item'));
      var same = 0;
      for (var k = 0; k < Math.min(last.line, domLines.length); k++) {
        var l = domLines[k].querySelector('a[href*="/cart/change"]');
        var vid = l ? parseInt((l.getAttribute('href').match(/[?&]id=(\d+)/) || [])[1], 10) : 0;
        if (vid === variantId) same++;
      }
      return matches[Math.max(0, Math.min(same, matches.length) - 1)];
    }
    return 0;
  }

  var nativeFetch = window.fetch;
  if (!nativeFetch) return;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isChange = /\/cart\/change(\.js)?(\?|$)/.test(url) && init && init.method && init.method.toUpperCase() === 'POST';
    if (!isChange || typeof init.body !== 'string') return nativeFetch.apply(this, arguments);

    var body;
    try { body = JSON.parse(init.body); } catch (e) { return nativeFetch.apply(this, arguments); }
    if (!body || !body.id || body.line) return nativeFetch.apply(this, arguments);

    var self = this, args = arguments;
    return nativeFetch.call(window, root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = resolveLine(body.id, cart);
        if (!line) return nativeFetch.apply(self, args); // can't resolve → let the theme try as-is
        var fixed = Object.assign({}, body, { line: line });
        delete fixed.id;
        var newInit = Object.assign({}, init, { body: JSON.stringify(fixed) });
        return nativeFetch.call(window, url, newInit);
      }, function () { return nativeFetch.apply(self, args); });
  };
})();
